import { agencyPath, createRequestWithComputedFilters } from '@/utils/api'
import store from '@/store'
import network from '@/utils/network'

/**
 * Récupère les devis de l'agence
 * @type {function(?{filters?: *, ...opt}): *}
 */
export const fetchAgencyEstimates = createRequestWithComputedFilters(
  async (params) => {
    const slugAgency = store.getters['user/agencySlug']
    const r = await network.post(`agency/${slugAgency}/fetch/estimates`, params)
    return r.data
  })

/**
 * Récupère un devis
 * @returns {Promise<>}
 */
export const getAgencyEstimate = async ({ reference }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}/estimate/${reference}`)
  return r.data
}

/**
 * Créé / met à jour un devis
 * @returns {Promise<>}
 */
export const postAgencyEstimate = async (estimate) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/estimate`, estimate)
  return r.data
}

/**
 * Créé / met à jour un devis
 * @returns {Promise<>}
 */
export const postPreviewEstimate = async (estimate) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/estimate/preview`, estimate)
  return r.data
}

/**
 * Récupère la liste des devis en rappel
 * @returns {Promise<any>}
 */
export const getEstimatesReminds = async () => {
  const r = await network.get(`${agencyPath()}/estimates/reminds`)
  return r.data
}
